import { computed, Ref, watch } from "vue";
import { useQuery, useQueryClient } from "@tanstack/vue-query";
import type { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import { ListProveedorAction } from "../../actions/proveedorActions";

export function useProveedoresList(params: Ref<PaginacionFilterParams>) {
  const queryClient = useQueryClient();

  // TanStack Query principal
  const query = useQuery({
    queryKey: ["ProveedoresList", params],
    queryFn: () => ListProveedorAction(params.value),
    staleTime: 60 * 1000, // cache de 1 min
  });

  // Extraer datos en forma reactiva
  const proveedores = computed(() => query.data.value?.data?.data?.proveedores || []);
  const total = computed(() => query.data.value?.data?.data?.total || 0);
  const totalPages = computed(() => query.data.value?.data?.data?.totalPages || 0);
  const currentPage = computed(() => query.data.value?.data?.data?.page || 1);

  // Prefetch cuando cambien los parámetros
  watch(
    params,
    (newParams) => {
      queryClient.prefetchQuery({
        queryKey: ["ProveedoresList", newParams],
        queryFn: () => ListProveedorAction(newParams),
      });
    },
    { deep: true }
  );

  return {
    ...query, // => { data, isLoading, isError, error, refetch, ... }
    proveedores,
    total,
    totalPages,
    currentPage,
  };
}
